import { useTranslations } from "../../contexts/Translation";
import { H1 } from "../Headers/Headings";
import Section from "../Section";
import HorizontalNavigation from "../HorizontalNavigation/HorizontalNavigation";
import ProfileForm from "../Forms/ProfileForm";
import OrganizationForm from "../Forms/OrganizationForm";
import { useOrganizations } from "../../contexts/UserProvider";
import { useEffect, useState } from "react";
import { useApiData } from "../../contexts/ApiData";
import SystemMessage from "../SystemMessage/Index";
import { Profile } from "../../types";
import UserManagement from "../Forms/UserManagement/UserManagement";
import { SubscriptionDetails } from "./SubscriptionDetails";
import { DataPrivacy } from "./DataPrivacy";

const Settings = () => {
  const t = useTranslations("settings");
  const [profile, setProfile] = useState<Profile | null>(null);
  const { currentOrganization } = useOrganizations();
  const { get } = useApiData();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const call = async () => {
      const response = await get("/profile");
      setProfile(response);
      setIsLoading(false);
    };
    call();
  }, [get]);

  if (isLoading || !profile) {
    return <SystemMessage message='loading' />;
  }

  const pages = [<ProfileForm profile={profile} isEdit />];
  const labels = [t("profile")];
  const tabKeys = ["profile"];

  const currentOrg = profile.roles.find((o) => o.orgId === currentOrganization);
  if (currentOrg?.role === "owner") {
    pages.push(<OrganizationForm isEdit />);
    pages.push(<UserManagement />);
    labels.push(t("organization"), t("members"));
    tabKeys.push("organization", "members");
  }

  pages.push(<SubscriptionDetails />);
  labels.push(t("subscription.settingsHeading"));
  tabKeys.push("subscription");

  pages.push(<DataPrivacy profile={profile} />);
  labels.push(t("dataPrivacy"));
  tabKeys.push("data-privacy");
  return (
    <Section span={8}>
      <H1 variant='compactBottom'>{t("heading")}</H1>
      <HorizontalNavigation labels={labels} pages={pages} queryParamKey='tab' tabKeys={tabKeys} />
    </Section>
  );
};

export default Settings;
